export default __webpack_public_path__ + "static/media/factor_right_bg.2c9bf9b2.png";